// extracted by mini-css-extract-plugin
module.exports = {"bigImage":"Image_bigImage__ALip1","smallImage":"Image_smallImage__2M8mT"};